import printHtml from '@/mixins/printHtml'

const productionDistillingPrintDistillation = {
  mixins: [printHtml],
  methods: {
    async printDistillation(id, process, print) {
      const isProcess = !!process;
      const results =  await this.$apiCall(`query productionDistillingPrintDistillation($id:ID!, $isProcess:Boolean!, $audit:Boolean!) {
                                              process(id:$id) @include(if:$isProcess) {
                                                name,description
                                                inputs {itemName,quantity,minQuantity,maxQuantity,precision,itemUnits}
                                                outputs {spiritName,nonExcise}
                                              }
                                              distillation(id:$id) @skip(if:$isProcess) {
                                                date,duration,siteName,stillName,completed
                                                processName,comments
                                                inputs {type,typeName,lot,vesselName,quantity,precision,units}
                                                outputs {spiritName,tankName,quantity,nonExcise}
                                                audit @include(if:$audit) {userName,time,event}
                                              }
                                              distillingPreferences {
                                                distillDuration
                                              }
                                            }`,
                                          {id, isProcess, audit:this.$store.getters.company.allowAudit});
      if (results.error)
        return;

      const distillation = isProcess ? results.data.process : results.data.distillation;
      const preferences = results.data.distillingPreferences;
      const lines = [`
        <style>
          @page {size:portrait}
          table {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;table-layout:fixed}
          td {padding:5px;height:30px;position:relative}
          .title {font-weight:bold;text-align:center;font-size:150%;padding-bottom:40px}
          .subtitle {font-weight:medium;text-align:center;height:10px}
          .box {${isProcess ? 'border-bottom:thin solid #aaa':''}}
          .label {display:inline-block;top:-8px;position:absolute;xbackground-color:#fff;xpadding-left:5px;xpadding-right:5px;font-size:90%}
          .suffix {display:inline-block${isProcess ? ';float:right' : ''}}
          .placeholder {${isProcess ? 'color:#888' : ''}}
          .half-line {height:20px}
          .hint {text-align:center; font-size:9px}
          .inner-table {border:thin solid #ccc; padding:10px}
          .page-break {page-break-before: always;}
          .incomplete {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${isProcess || distillation.completed ? '' : `<tr><td colspan="20" class="incomplete">INCOMPLETE</td></tr>`}
            <tr><td colspan="20" class="subtitle">${this.company.name}</td></tr>
            <tr><td colspan="20" class="title">Distillation</td></tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" class="box"><div class="label">Date</div>
                <span class="placeholder">
                  ${isProcess?`${process.date ? this.$formatDateTime(process.date) : ''}`:this.$formatDateTime(distillation.date)}
                </span>
              </td>
              <td/>
              ${preferences.distillDuration ? `<td colspan="4" class="box"><div class="label">Duration</div>${isProcess?'':this.$options.filters.duration(distillation.duration)}</td>` : '<td colspan="4"/>'}
              <td colspan="4"/>
              ${this.$store.getters.sites(true, {B266:true}).length ? `<td colspan="6" class="box"><div class="label">Site</div>
                ${isProcess?process.siteName??'':distillation.siteName}
              </td>` : '<td colspan="6"/>'}
            </tr>
            <tr><td colspan="20"/></tr>
            <tr>
              <td colspan="5" class="box"><div class="label">Process</div>${isProcess?distillation.name:distillation.processName}</td>
              <td colspan="9"/>
              <td colspan="6" class="box"><div class="label">Still</div>${isProcess?'':distillation.stillName}</td>
            </tr>
            ${distillation.description ? `<tr><td colspan="10">${distillation.description}</td></tr><tr><td colspan="20" class="half-line"/></tr>` : '<tr><td colspan="20"/></tr>'}
            <tr><td colspan="20" class="half-line"/></tr>

            <tr>
              <td colspan="20" class="inner-table">
                <table>

            <tr>
              <td colspan="8" class="half-line"><strong>Distillation input</strong></td>
              <td/>
              <td colspan="4" class="half-line"><strong>Tank or Lot</strong></td>
              <td/>
              <td colspan="6" class="half-line"><strong>Quantity</strong></td>
            </tr>
        `];

      for (const item of distillation.inputs) {
        lines.push(`
          <tr>
            <td colspan="8" class="box">${isProcess?item.itemName:item.typeName}</td>
            <td/>
            <td colspan="4" class="box">${isProcess?'':(item.type !== 'Item' ? item.vesselName : item.lot ?? '')}</td>
            <td/>
            <td colspan="6" class="box">
              <span class="${item.minQuantity !== item.quantity || item.maxQuantity !== item.quantity ? 'placeholder' : ''}">${this.$number(item.quantity, item.precision)}</span>
              <div class="suffix">${isProcess?item.itemUnits:item.units}</div>
            </td>
          </tr>`);
        if (isProcess)
          lines.push(`
          <tr>
            <td colspan="14" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${!isProcess || item.minQuantity === item.quantity && item.maxQuantity === item.quantity ? '' :
               `${item.minQuantity || item.maxQuantity ? 'Must be ' : ''}
                ${item.minQuantity ? `>= ${this.$number(item.minQuantity, item.precision)}` : ''}
                ${item.minQuantity && item.maxQuantity ? ' and ' : ''}
                ${item.maxQuantity ? `<= ${this.$number(item.maxQuantity, item.precision)}` : ''}`
              }
            </td>
          </tr>
        `);
      }
      if (isProcess)
        lines.push(`
          <tr>
            <td colspan="8" class="box"></td>
            <td/>
            <td colspan="4" class="box"></td>
            <td/>
            <td colspan="6" class="box"></td>
          </tr>`);
      lines.push(`
          </table>
      </td>
    </tr>

        <tr><td colspan="20" class="half-line"/></tr>
        <tr>
        <td colspan="20" class="inner-table">
          <table>

        <tr>
          <td colspan="7" class="half-line"><strong>Output</strong></td>
          <td/>
          <td colspan="7" class="half-line"><strong>Tank</strong></td>
          <td/>
          <td colspan="4" class="half-line"><strong>Quantity</strong></td>
        </tr>`);

      if (isProcess) {
        for (const output of distillation.outputs)
          lines.push(`
              <tr>
                <td colspan="7" class="box">${output.spiritName}</td>
                <td/>
                <td colspan="7" class="box"></td>
                <td/>
                <td colspan="4" class="box">
                  <div class="suffix">${output.nonExcise?'litres':'LAA'}</div>
                </td>
              </tr>
              <tr><td class="half-line"/></tr>`);
        lines.push(`
                  <tr>
                    <td colspan="7" class="box"></td>
                    <td/>
                    <td colspan="7" class="box"></td>
                    <td/>
                    <td colspan="4" class="box"></td>
                  </tr>`);
      }
      else
        for (const output of distillation.outputs)
          lines.push(`
                      <tr>
                      <td colspan="7" class="box">${output.spiritName}</td>
                      <td/>
                      <td colspan="7" class="box">${output.tankName}</td>
                      <td/>
                      <td colspan="4" class="box">${this.$number(output.quantity,3)}
                        <div class="suffix">${output.nonExcise?'litres':'LAA'}</div>
                      </td>
                    </tr>`);

      lines.push(`
        </table>
      </td>
    </tr>

        <tr><td/></tr>
        <tr>
          <td colspan="20" class="box" style="height:60px"><div class="label">Comments</div>
          ${isProcess?'':distillation.comments}
          </td>
        </tr>`);

      if (isProcess)
        lines.push(`
        <tr><td/></tr>
        <tr><td/></tr>
        <tr>
          <td colspan="8" class="box"><div class="label">Performed by</div><div class="placeholder">${process.performBy}</div></td>
          <td/>
          <td colspan="8" class="box"><div class="label">Signature</div></td>
        </tr>`);

      else if (this.$store.getters.company.allowAudit) {
        lines.push(`<tr>
                      <td colspan="4"><strong>Date</strong></td>
                      <td/>
                      <td colspan="5"><strong>User</strong></td>
                      <td/>
                      <td colspan="9"><strong>Action</strong></td>
                    </tr>`);
        for (const audit of distillation.audit)
          lines.push(`<tr>
                        <td colspan="4">${this.$formatDateTime(audit.time)}</td>
                        <td/>
                        <td colspan="5">${audit.userName}</td>
                        <td/>
                        <td colspan="9">${audit.event}</td>
                      </tr>`);
      }

      lines.push(`
        </tbody>
        </table>
      `);

      if (print)
        this.printHtml('Distillation',lines.join(''));
      else
        return lines;
    }
  }
}

export default productionDistillingPrintDistillation;